const STATUS_LABELS: Record<string, string> = {
  active: 'Hoạt động',
  inactive: 'Không hoạt động',
  pending: 'Chờ duyệt',
};

const STATUS_COLORS: Record<string, string> = {
  active: '#22c55e',
  inactive: '#f97316',
  pending: '#f59e0b',
};

export type EmployeeStatusMeta = {
  id: string;
  name: string;
  color: string;
};

/**
 * Chuẩn hóa trường status từ API (string hoặc object) thành id dùng cho form Select.
 */
export const resolveEmployeeStatusId = (
  status: unknown,
  fallback = 'active'
): string => {
  if (status == null || status === '') {
    return fallback;
  }

  if (typeof status === 'string') {
    const trimmed = status.trim();
    return trimmed || fallback;
  }

  if (typeof status === 'number') {
    return String(status);
  }

  if (typeof status === 'object') {
    const record = status as Record<string, unknown>;
    const candidates = [record.id, record.status_id, record.code, record.value];

    for (const candidate of candidates) {
      if (typeof candidate === 'string' && candidate.trim()) {
        return candidate.trim();
      }
      if (typeof candidate === 'number') {
        return String(candidate);
      }
    }
  }

  return fallback;
};

/** Chuẩn hóa status để hiển thị label/color (thùng rác, bảng list, …). */
export const resolveEmployeeStatusMeta = (
  status: unknown,
  fallback = 'active',
): EmployeeStatusMeta => {
  const id = resolveEmployeeStatusId(status, fallback);

  if (status && typeof status === 'object') {
    const record = status as Record<string, unknown>;
    const name = typeof record.name === 'string' ? record.name.trim() : '';
    const color = typeof record.color === 'string' ? record.color.trim() : '';
    return {
      id,
      name: name || STATUS_LABELS[id] || id,
      color: color || STATUS_COLORS[id] || '#64748b',
    };
  }

  return {
    id,
    name: STATUS_LABELS[id] || id,
    color: STATUS_COLORS[id] || '#64748b',
  };
};
